import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useNavigate,
  useLocation,
  Navigate,
} from "react-router-dom";
import "../App.css";
import Mint from "./Mint";
import Send from "./Send";
import LockRedeem from "./LockRedeem";
import ScanQr from "./ScanQr";
import Burn from "./Burn";
import Header from "./Header";
import Request from "./Request";
import { Container, Tabs, Tab, Box } from "@mui/material";
import WhitelistManager from "./WhitelistManager";
import { getEnrollmentIdFromWallet } from "../extensionMethods/app";
import { DAPP_NAME, TransactionName, DAPP_ICON } from "../constants";
import config from "../config";
import { ExecuteReadTransaction } from "../utils";
import BigNumber from "bignumber.js";
import Success from "./success";

function MainApp() {
  const [activeTab, setActiveTab] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const [balance, setBalance] = useState("");
  const [address, setAddress] = useState("");
  const [isConnected, setIsConnected] = useState(false);

  useEffect(() => {
    const fetchEnrollmentId = async () => {
      try {
        console.log("Inside fetchEnrollmentId");
        const dappToken = localStorage.getItem("opensea_dappToken") || "";
        if (!dappToken) return;
        console.log("Before getEnrollmentIdFromWallet");
        const res = await getEnrollmentIdFromWallet(
          dappToken,
          DAPP_NAME,
          config.DAPP_URL,
          DAPP_ICON
        );
        console.log("After getEnrollmentIdFromWallet", res);
        if (res) {
          setAddress(res);
          localStorage.setItem("opensea_enrollmentId", res);
        }
      } catch (error) {
        console.error("Error fetching enrollmentId:", error);
      }
    };
    fetchEnrollmentId();
  }, [isConnected]);

  useEffect(() => {
    const fetchBalance = async () => {
      try {
        const [balance, errMsg] = await ExecuteReadTransaction(
          config.CHANNEL_NAME,
          config.CHAINCODE_NAME,
          TransactionName.BALANCE, // Ensure the correct transaction name
          [address] // Pass vendor address as the parameter
        );
        console.log("Balance response: ", balance);
        if (balance) {
          setBalance(new BigNumber(balance?.response).dividedBy(100));
        } else {
          throw new Error(errMsg);
        }
      } catch (error) {
        console.error("Error fetching balance:", error);
      }
    };

    if (address) {
      fetchBalance(); // Fetch balance only when vendorAddress is available
    }
  }, [address]);

  const handleChange = (event, newValue) => {
    navigate(newValue);
  };

  // Sync tab with the URL when the app loads or URL changes
  useEffect(() => {
    if (location.pathname == "/") {
      setActiveTab("/send");
    } else {
      setActiveTab(location.pathname);
    }
  }, [location.pathname]);

  return (
    <div className="background">
      <Header isConnected={isConnected} setIsConnected={setIsConnected} />
      <Container
        maxWidth="md"
        sx={{
          marginTop: "100px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            width: "100%",
            maxWidth: "800px",
            backgroundColor: "#EBEDF2", // Background color for the card/box
            borderRadius: "20px",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)", // Subtle shadow for effect
            border: "1px solid #e0e0e0",
            overflow: "hidden",
          }}
        >
          <Tabs
            value={activeTab}
            onChange={handleChange}
            sx={{
              "& .MuiTabs-flexContainer": {
                justifyContent: "space-evenly",
              },
              "& .MuiTab-root": {
                flex: 1,
                textTransform: "none",
                fontWeight: "bold",
              },
              backgroundColor: "#ffffff",
              borderBottom: "1px solid #e0e0e0",
            }}
            variant="fullWidth"
          >
            <Tab label="Send" value="/send" />
            <Tab label="Receive" value="/receive" />
            <Tab label="Request" value="/request" />
            <Tab label="Lock" value="/lock" />
          </Tabs>
          <Box
            sx={{
              padding: { xs: "20px", md: "40px" },
              minHeight: "300px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "#f2f4f6", // Background inside the tab content area
            }}
          >
            <Routes>
              <Route
                path="/send"
                isConnected={isConnected}
                element={
                  <Send
                    balance={balance}
                    setBalance={setBalance}
                    isConnected={isConnected}
                  />
                }
              />
              <Route
                path="/receive"
                element={
                  <ScanQr
                    balance={balance}
                    vendorAddress={address}
                    isConnected={isConnected}
                  />
                }
              />
              <Route
                path="/request"
                element={
                  <Request
                    address={address}
                    isConnected={isConnected}
                    setIsConnected={setIsConnected}
                  />
                }
              />
              <Route
                path="/lock"
                element={
                  <LockRedeem
                    balance={balance}
                    setBalance={setBalance}
                    walletConnected={isConnected}
                    isConnected={isConnected}
                  />
                }
              />
              <Route
                path="/"
                element={
                  <Send
                    balance={balance}
                    setBalance={setBalance}
                    isConnected={isConnected}
                  />
                }
              />{" "}
              {/* Default route */}
              <Route path="*" element={<Navigate to="/" replace />} />
              <Route path="/success" element={<Success />} />

            </Routes>
          </Box>
        </Box>
      </Container>
    </div>
  );
}

function UserPanel() {
  return (
    <Router>
      <MainApp />
    </Router>
  );
}

export default UserPanel;
